const SupportLanguages = {
  en: 'English',
  fr: 'French',
  es: 'Spanish',
  de: 'German',
  pt: 'Portuguese',
  ja: 'Japanese'
};
export default SupportLanguages;